export function selectNoneAction() {
  const { t } = useI18n();
  const viewerStore = useViewerStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.select_none') || 'Select None',
    getEnabled: function (context) {
      return context.viewer.scene.numSelectedObjects > 0;
    },
    doAction: function (context) {
      context.viewer.scene.setObjectsSelected(context.viewer.scene.selectedObjectIds, false);
      viewerStore.propertiesInspector.metaObjects = {};
    },
  };
}
